export const actionTypes = {
    FETCH_ABOUT_HEADER_RECIPE: 'FETCH_ABOUT_HEADER_RECIPE',
    FETCH_ABOUT_HEADER_RECIPE_SUCCESS: 'FETCH_ABOUT_HEADER_RECIPE_SUCCESS',
}